<template>
  <div class="photophone">
    <div id="works" ref="works">
      <navigator-work
        label="Photo Phone"
        section="Photo Phone"
        previous_section="Home"
        previous_url="/"
      />
    </div>

    <div class="content">
      <div class="information">
        <div id="principal-text-div">
          <p>
            ﾟ･*:.｡*:ﾟ･♡<br />
            .｡.:*✧ galeria sin razón<br />
            no reason gallery ✧*:.｡.<br />
            ♡･ﾟ:*｡.:*･ﾟ
          </p>
        </div>
        <!-- <div><p id="secondary-text-div"> photo phone <br/></p></div> -->
        <div id="image-information">
          <img src="@/assets/photophone/cachorro.gif" width="230" alt="" />
        </div>
      </div>

      <div class="photos_photofone">
        <vue-load-image v-for="(item, index) in images" :key="index">
          <div 
            slot="preloader" 
            class="skeleton-loader"
            :style="{ animationDelay: (index * 0.15) + 's' }"
          ></div>
          <img
            slot="image"
            class="image-gallery"
            :src="resolve_img_server(item.image)"
            height="384px"
            :alt="item.description"
            @click="showGallery(index)"
          />
        </vue-load-image>
      </div>
    </div>

    <div v-if="image.visible">
      <div class="background-gallery" />
      <div 
        id="navigation-left" 
        @click="leftImage"
        class="navigation-button"
      >
        <img src="@/assets/works/cursor-izq.png" height="40px" alt="Previous" />
      </div>
      <div 
        id="navigation-right" 
        @click="rightImage"
        class="navigation-button"
      >
        <img src="@/assets/works/cursor-der.png" height="40px" alt="Next" />
      </div>
      <img
        id="image"
        :src="resolve_img_server(image.name)"
        :alt="image.description"
        height="600px"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
      />
      <div id="close_image" @click="hideGallery">
        <img alt="Cerrar" src="@/assets/gallery/cruz_info.png" height="30px" />
      </div>
    </div>
  </div>
</template>

<script>
import NavigatorWork from "@/components/NavigatorWork.vue";
import axios from "axios";
import VueLoadImage from "vue-load-image";

export default {
  name: "PhotoPhone",
  components: { NavigatorWork, VueLoadImage },
  data() {
    return {
      images: [],
      image: {
        visible: false,
        name: "",
        description: "",
      },
      actual_image_index: 0,
      location_cursor: "",
      touchStartX: 0,
      touchEndX: 0,
    };
  },
  methods: {
    async getData() {
      try {
        const [left, right] = await Promise.all([
          axios.get("https://api.ladraaaaa.com/api/photophone/left_photos/"),
          axios.get("https://api.ladraaaaa.com/api/photophone/right_photos/"),
        ]);
        this.images = [...left.data, ...right.data];
      } catch (error) {
        console.log(error);
      }
    },
    showGallery(index) {
      this.actual_image_index = index;
      this.image.name = this.images[index].image;
      this.image.description = this.images[index].description || "";
      this.image.visible = true;
      window.addEventListener("keyup", this.keyup);
    },
    leftImage() {
      const n = this.images.length;
      this.actual_image_index = (this.actual_image_index - 1 + n) % n;
      this.image.name = this.images[this.actual_image_index].image;
      this.image.description =
        this.images[this.actual_image_index].description || "";
    },
    rightImage() {
      const n = this.images.length;
      this.actual_image_index = (this.actual_image_index + 1) % n;
      this.image.name = this.images[this.actual_image_index].image;
      this.image.description =
        this.images[this.actual_image_index].description || "";
    },
    keyup: function(event) {
      const actions = {
        Escape: () => this.hideGallery(),
        ArrowLeft: () => this.leftImage(),
        ArrowRight: () => this.rightImage(),
      };
      const action = actions[event.key];
      if (action) {
        event.preventDefault();
        action();
      }
    },
    hideGallery() {
      this.image.visible = false;
      window.removeEventListener("keyup", this.keyup);
    },
    handleTouchStart(event) {
      this.touchStartX = event.changedTouches[0].screenX;
    },
    handleTouchMove(event) {
      this.touchEndX = event.changedTouches[0].screenX;
      event.preventDefault();
    },
    handleTouchEnd() {
      const swipeThreshold = 50;
      const diff = this.touchStartX - this.touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          this.rightImage();
        } else {
          this.leftImage();
        }
      }
    },
    resolve_img_server(path) {
      const url = "https://api.ladraaaaa.com/" + path;
      // TODO: REMOVE THIS DELAY - Only for testing skeleton loader
      // return url + "?delay=" + Math.random();
      return url;
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Paprika&display=swap");

/* Local variables and base layout (mobile-first) */
.photophone {
  --bg: #252323;
  --accent: #03ff00;
  --font: "Paprika", serif;

  --gap: 12px;
  --panel-width: 100%;
  --grid-min: 180px;
  --radius: 8px;
  --shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  --shadow-hover: 0 6px 14px rgba(0, 0, 0, 0.25);

  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
}

.photophone::before {
  background: var(--bg);
  content: "";
  position: fixed;
  inset: 0;
  z-index: -1;
}

#works {
  margin-top: 33px;
  position: relative;
  z-index: 10;
}

.content {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--gap);
  align-items: start;
}

.information {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

#principal-text-div {
  color: var(--accent);
  font-family: var(--font);
  align-self: center;
  text-align: left;
  padding: 32px 0;
  margin: 60px auto 0;
  font-size: 16px;
  line-height: 1.35;
  max-width: none;
}

#image-information {
  display: none;
}

.photos_photofone {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--grid-min), 1fr));
  gap: var(--gap);
}

.skeleton-loader {
  width: 100%;
  aspect-ratio: 3/4;
  background: #2d2b2b;
  border-radius: var(--radius);
  animation: pulse 1s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    background-color: #2d2b2b;
  }
  50% {
    background-color: #3a3838;
  }
}

.image-gallery {
  width: 100%;
  height: auto;
  display: block;
  border-radius: var(--radius);
  object-fit: cover;
  box-shadow: var(--shadow);
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.image-gallery:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-hover);
}

.background-gallery {
  z-index: 98;
  background: rgba(37, 35, 35, 0.8);
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  position: fixed;
}

.navigation-button {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  z-index: 101;
  cursor: pointer;
  padding: 20px;
  transition: opacity 0.2s;
  opacity: 0.7;
  display: none;
}

.navigation-button:hover {
  opacity: 1;
}

#navigation-left {
  left: 20px;
}

#navigation-right {
  right: 20px;
}

#image {
  z-index: 100;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 90vw;
  max-height: 90vh;
  width: auto;
  height: auto;
}

#close_image {
  z-index: 100;
  position: fixed;
  top: 3%;
  right: 3%;
  cursor: pointer;
}

@media (min-width: 768px) {
  .photophone {
    --gap: 16px;
    --panel-width: 250px;
    --grid-min: 180px;
  }
  .content {
    grid-template-columns: var(--panel-width) 1fr;
  }
  #principal-text-div {
    margin-top: 120px;
    max-width: 220px;
  }
  #image-information {
    display: block;
  }
}

@media (min-width: 1024px) {
  .photophone {
    --grid-min: 220px;
  }
  #principal-text-div {
    margin-top: 200px;
    max-width: 200px;
  }
  .navigation-button {
    display: block;
  }
}

@media (min-width: 1280px) {
  .photophone {
    --gap: 20px;
    --grid-min: 260px;
  }
}
</style>
